import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { Facility } from '../models/Facility';

export class FacilityService {
  static async getAllFacilities(): Promise<Facility[]> {
    try {
      const q = query(
        collection(db, 'facilities'),
        orderBy('name', 'asc')
      );
      
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      } as Facility));
    } catch (error) {
      console.error('시설물 목록 조회 실패:', error);
      return [];
    }
  }
} 